<div bsModal #webshopItemDetails="bs-modal" class="modal fade" tabindex="-1" (onShown)="onShown()" role="dialog"
     aria-labelledby="createOrEditModal" aria-hidden="true" [config]="{backdrop: 'static'}">
    <div class="modal-dialog modal-lg m-w-80">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    <span translation="Axilla.Article.ItemDetails" source="Axilla"></span>
                </h4>
                <button type="button" class="close" (click)="close()" aria-label="Close" [disabled]="saving">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body item-modal" [ngClass]="selectedTemplate" *ngIf="active">
                <div class="w-100" [ngSwitch]="selectedTemplate">
                    <!-- Template for Type 'legacy' -->
                    <div *ngSwitchCase="'legacy'" class="p-col-12 list-item">
                        <ng-container *ngIf="BasePermissionDefinition.Webshop.View.ShowFavoriteArticles | permission">
                            <div class="favorite-container" (click)="addToFavorite($event, selectedItems)">
                                <i class="fa fa-heart" [ngClass]="{'selected': selectedItems.favorite}"></i>
                            </div>
                        </ng-container>
                        <div class="product-list-item list-card p-0">
                            <div class="product-list-detail d-flex">
                                <div class="product-image">
                                    <img [src]="getImgUrl(selectedItems.code)" alt="Article picture"/>
                                </div>
                                <div>
                                    <div class="product-name">{{ selectedItems.title }}</div>
                                    <div class="product-description">{{ selectedItems.code }}</div>
                                    <div class="product-description">{{ selectedItems.description }}</div>
                                    <!--<p-rating [value]="5" [readonly]="false" [cancel]="false"></p-rating>-->
                                    <ng-container *ngFor="let category of selectedItems.categories">
                                        <i class="pi pi-tag product-category-icon"></i><span
                                        class="product-category">{{ category.shortName }}</span>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="product-list-action" (click)="preventClick($event)">
                                <span *ngIf="selectedItems.amount == 1" class="product-badge amount-pce">
                                    <span translation="Axilla.OrderGuide.Article.AmountPce" source="Axilla"></span>
                                </span>
                                <span *ngIf="selectedItems.amount > 1" class="product-badge amount-box">
                                    {{ selectedItems.amount }}
                                    <span *ngIf="selectedItems.amount > 1"
                                          translation="Axilla.OrderGuide.Article.AmountBox" source="Axilla">
                                    </span>
                                </span>

                                <ng-container *ngIf="'Pages.App.Webshop.View.ShowAvailableStockInfo' | permission">
                                    <div class="list-details-stock-container" *ngIf="isStockAvailable(selectedItems)">
                                        {{ selectedItems.stockAmount }}
                                        <span *ngIf="selectedItems.stockAmount == 1 && selectedItems.amount == 1"
                                              translation="Axilla.Apps.Webshop.OnStock.Piece1"
                                              source="AxillaAppWebshop"> </span>
                                        <span *ngIf="selectedItems.stockAmount == 1 && selectedItems.amount > 1"
                                              translation="Axilla.Apps.Webshop.OnStock.Box1"
                                              source="AxillaAppWebshop"> </span>
                                        <span *ngIf="selectedItems.stockAmount > 1 && selectedItems.amount == 1"
                                              translation="Axilla.Apps.Webshop.OnStock.Piece"
                                              source="AxillaAppWebshop"> </span>
                                        <span *ngIf="selectedItems.stockAmount > 1 && selectedItems.amount > 1"
                                              translation="Axilla.Apps.Webshop.OnStock.Box"
                                              source="AxillaAppWebshop"> </span>
                                    </div>

                                    <div class="list-details-stock-container sold-out"
                                         *ngIf="isStockAvailable(selectedItems) && selectedItems.stockAmount == 0">
                                        Sold OUT
                                    </div>
                                </ng-container>

                                <ng-container *ngIf="'Pages.App.Webshop.View.ShowAvailableStockInfo' | permission">
                                    <div class="list-details-stock-container" *ngIf="isGapAvailable(selectedItems)">
                                        {{ selectedItems.availableAmount }}

                                        <span *ngIf="selectedItems.availableAmount == 1 && selectedItems.amount == 1"
                                              translation="Axilla.Apps.Webshop.Available.Piece1" source="Axilla"></span>
                                        <span *ngIf="selectedItems.availableAmount == 1 && selectedItems.amount > 1"
                                              translation="Axilla.Apps.Webshop.Available.Box1" source="Axilla"></span>
                                        <span *ngIf="selectedItems.availableAmount > 1 && selectedItems.amount == 1"
                                              translation="Axilla.Apps.Webshop.Available.Piece" source="Axilla"></span>
                                        <span *ngIf="selectedItems.availableAmount > 1 && selectedItems.amount > 1"
                                              translation="Axilla.Apps.Webshop.Available.Box" source="Axilla"></span>
                                    </div>
                                </ng-container>

                                <div>
                                    <span class="product-price">
                                        {{ selectedItems.price | currency:getCurrency():'symbol-narrow':'.2-2' }}
                                    </span>
                                    <p-spinner [(ngModel)]="selectedItems.quantity"
                                               [step]="1"
                                               [min]="0"
                                               OnlyNumber="true"
                                               inputStyleClass="item-quantity"
                                               [formatInput]="true"
                                               (onChange)="calculateAvailable()"
                                               thousandSeparator=","
                                               decimalSeparator="."></p-spinner>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Template for Type 'theme1' -->
                    <div *ngSwitchCase="'theme1'" class="p-col-12 list-item">
                        <div class="product-list-item list-card p-0">
                            <ng-container *ngIf="'Pages.App.Webshop.View.ShowAvailableStockInfo' | permission">
                                <div class="product-list-information"
                                     *ngIf="selectedItems.promotionText || (isStockAvailable(selectedItems) && selectedItems.stockAmount == 0)">
                                    <div class="sold-out" *ngIf="isStockAvailable(selectedItems) && selectedItems.stockAmount == 0">
                                        Sold OUT
                                    </div>

                                    <div class="product-promotion" *ngIf="selectedItems.promotionText">
                                        {{ selectedItems.promotionText }}
                                    </div>
                                </div>
                            </ng-container>

                            <div class="product-list-detail d-flex">
                                <div class="product-image">
                                    <img [src]="getImgUrl(selectedItems.code)" alt="Article picture"/>

                                    <ng-container *ngIf="BasePermissionDefinition.Webshop.View.ShowFavoriteArticles | permission">
                                        <div class="favorite-container" (click)="addToFavorite($event, selectedItems)">
                                            <i class="fa fa-heart" [ngClass]="{'selected': selectedItems.favorite}"></i>
                                        </div>
                                    </ng-container>
                                </div>
                                <div class="product-info">
                                    <div class="product-name">{{ selectedItems.title }}</div>
                                    <div class="product-code">{{ selectedItems.code }}</div>
                                    <div class="product-categories" *ngIf="isCategoriesAvailable(selectedItems)">
                                        <ng-container *ngFor="let category of selectedItems.categories">
                                            <p-tag icon="pi pi-tag" [styleClass]="'product-category-item'"
                                                   [rounded]="true" value="{{category.shortName}}"></p-tag>
                                        </ng-container>
                                    </div>
                                    <div class="product-description">{{ selectedItems.description }}</div>
                                </div>

                                <div class="product-price-section">
                                    <div class="price-container">
                                        <span class="original-price" *ngIf="selectedItems.showOldPrice">
                                            {{ selectedItems.oldPrice | currency:getCurrency(selectedItems.currency):'symbol-narrow':'.2-2' }}
                                        </span>
                                        <span class="current-price">
                                            {{ selectedItems.price | currency:getCurrency(selectedItems.currency):'symbol-narrow':'.2-2' }}
                                        </span>
                                    </div>

                                    <div class="purchase-price-section" *ngIf="selectedItems.showPurchasePrice">
                                        <span class="pp-text">Purchase price</span>
                                        <span class="purchase-price">
                                            {{ selectedItems.purchasePrice | currency:getCurrency(selectedItems.currency):'symbol-narrow':'.2-2' }}
                                        </span>
                                    </div>
                                    <div class="box-info">
                                        <span *ngIf="selectedItems.amount == 1" class="product-badge amount-pce">
                                            {{ "Axilla.OrderGuide.Article.AmountPce" | localize }}
                                        </span>
                                        <span *ngIf="selectedItems.amount > 1" class="product-badge amount-box">
                                            {{ selectedItems.amount }}
                                            {{ "Axilla.OrderGuide.Article.AmountBox" | localize }}
                                        </span>
                                    </div>

                                    <div class="p-d-flex gap-2">
                                        <div class="p-d-flex gap-2 p-2">
                                            <i class="fa fa-warehouse"></i>
                                            <span>{{ selectedItems.stockAmount }}</span>
                                        </div>
                                        <div class="p-d-flex gap-2 p-2">
                                            <i class="pi pi-car"></i>
                                            <span>{{ selectedItems.localWarehouseAmount }}</span>
                                        </div>
                                    </div>

                                    <ng-container *ngIf="'Pages.App.Webshop.View.ShowAvailableStockInfo' | permission">
                                        <div class="list-details-stock-container"
                                             *ngIf="isStockAvailable(selectedItems) && selectedItems.stockAmount != 0">
                                            {{ selectedItems.stockAmount }}
                                            <span *ngIf="selectedItems.stockAmount == 1 && selectedItems.amount == 1"
                                                  translation="Axilla.Apps.Webshop.OnStock.Piece1"
                                                  source="AxillaAppWebshop"> </span>
                                            <span *ngIf="selectedItems.stockAmount == 1 && selectedItems.amount > 1"
                                                  translation="Axilla.Apps.Webshop.OnStock.Box1"
                                                  source="AxillaAppWebshop"> </span>
                                            <span *ngIf="selectedItems.stockAmount > 1 && selectedItems.amount == 1"
                                                  translation="Axilla.Apps.Webshop.OnStock.Piece"
                                                  source="AxillaAppWebshop"> </span>
                                            <span *ngIf="selectedItems.stockAmount > 1 && selectedItems.amount > 1"
                                                  translation="Axilla.Apps.Webshop.OnStock.Box"
                                                  source="AxillaAppWebshop"> </span>
                                        </div>

                                    </ng-container>

                                    <ng-container *ngIf="'Pages.App.Webshop.View.ShowAvailableStockInfo' | permission">
                                        <div class="list-details-stock-container" *ngIf="isGapAvailable(selectedItems)">
                                            {{ selectedItems.availableAmount }}

                                            <span *ngIf="selectedItems.availableAmount == 1 && selectedItems.amount == 1"
                                                  translation="Axilla.Apps.Webshop.Available.Piece1"
                                                  source="Axilla"></span>
                                            <span *ngIf="selectedItems.availableAmount == 1 && selectedItems.amount > 1"
                                                  translation="Axilla.Apps.Webshop.Available.Box1"
                                                  source="Axilla"></span>
                                            <span *ngIf="selectedItems.availableAmount > 1 && selectedItems.amount == 1"
                                                  translation="Axilla.Apps.Webshop.Available.Piece"
                                                  source="Axilla"></span>
                                            <span *ngIf="selectedItems.availableAmount > 1 && selectedItems.amount > 1"
                                                  translation="Axilla.Apps.Webshop.Available.Box"
                                                  source="Axilla"></span>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div class="product-list-actions">
                                <div class="product-basket-container">
                                    <div *ngIf="isInBasket(selectedItems)" class="p-d-flex gap-2">
                                        <i class="pi pi-shopping-cart"></i>
                                        <span>{{ getBasketAmount(selectedItems) }}</span>
                                    </div>
                                </div>
                                <!-- Quick Add Section -->
                                <div>
                                    <app-quick-add
                                        [label]="'Add to cart in one click:'"
                                        [quickAddAmounts]="getQuickAddAmounts(selectedItems)"
                                        [article]="selectedItems"
                                        (onQuickAction)="addToBasket($event)"></app-quick-add>
                                </div>
                                <div>
                                    <app-universal-counter [mode]="'horizontal'"
                                                           [showAdd]="false"
                                                           [article]="selectedItems"
                                                           (onChangeCounter)="calculateAvailable()"
                                                           (addToBasket)="addToBasket($event)"></app-universal-counter>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="item-details-footer d-flex align-items-center justify-content-end" [ngClass]="{'justify-content-between': 'Pages.App.Webshop.View.ShowAvailableStockInfo' | permission}">
                    <ng-container *ngIf="selectedItems">
                        <div class="d-flex" *ngIf="'Pages.App.Webshop.View.ShowAvailableStockInfo' | permission">
                            <ng-container *ngIf="showAvailableAmount">
                                <div class="available-items-container ubl-mint-leaf">
                                    {{ availableAmount }}
                                    <!--<span translation="Axilla.Webshop.AvailableItems" source="Axilla"></span>-->
                                    Available
                                </div>
                            </ng-container>

                            <ng-container *ngIf="deficiteItems > 0">
                                <div class="dificite-amount-container ubl-pink-glamour">
                                    {{ deficiteItems }}
                                    {{ deficiteWaitingTime }}
                                    <!--<span translation="Axilla.Webshop.ItemAvailability" source="Axilla"></span>-->
                                    weeks
                                </div>

                            </ng-container>
                        </div>
                    </ng-container>

                    <div class="item-details-button-container">
                        <button [disabled]="saving"
                                type="button"
                                class="btn btn-primary"
                                (click)="close()">
                            {{ l("Close") }}
                        </button>
                        <p-button icon="pi pi-shopping-cart" label="Add to Cart" (click)="onSave()"></p-button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
